import type { RowTypeKey } from '@tryhackme/thm-ui-components';
import { differenceInDays, formatDistanceToNowStrict } from 'date-fns';

import type { SetActiveSortColumnFunction, SetFeedbackParamsFunction, UserFeedbackItem } from './user-feedback.types';

export const formatDateAgo = (dateString: string) => {
  const now = new Date();
  const parsedDate = new Date(dateString);

  const diffInDaysFromNow = differenceInDays(now, parsedDate);

  return diffInDaysFromNow === 0
    ? 'Added today'
    : formatDistanceToNowStrict(parsedDate, { addSuffix: true, unit: 'day' });
};

export const sortData = (
  setActiveSortColumn: SetActiveSortColumnFunction,
  setFeedbackParams: SetFeedbackParamsFunction,
  columnKey: RowTypeKey<UserFeedbackItem>,
) => {
  setActiveSortColumn(columnKey);
  setFeedbackParams((prevParams) => ({
    ...prevParams,
    sort: prevParams.sort === columnKey.toString() ? `-${columnKey.toString()}` : columnKey.toString(),
  }));
};
